import { gql } from '@apollo/client';

export const GET_ELEMENTS = gql`
  query GetElements($projectId: Int!) {
    elements(parent_id: $projectId) {
      list {
        id
        name
        children_count
      }
    }
  }
`;

export const GET_ALL_ELEMENTS = gql`
  query GetAllElements($projectId: Int!) {
    elements(parent_id: $projectId, descendants: true) {
      list {
        id
        name
        children_count
        parent_id
      }
    }
  }
`;
